module.exports = __webpack_public_path__ + "img/circle_img1.3ca07718.png";